<template>
  <div class="history-empty">
    <div class="figure"></div>
    <div class="msg">还没有创建版本</div>
    <div class="msg-lite">版本记录帮您回溯项目创作历史，轻松还原到某一关键节点。</div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.history-empty {
  position: relative;
}
.msg {
  padding-bottom: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(72, 66, 98, 1);
}
.msg-lite {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(150, 146, 170, 1);
  line-height: 1.8;
}
.figure {
  width:118px;
  height:178px;
  background: no-repeat url(../../../static/svg/versionControl/empty-figure.png);
  background-size: 100% 100%;
  margin: auto;
  margin-bottom: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/historyEmpty.vue